export default __webpack_public_path__ + "static/media/header_Logo_AGP.40fb791c.png";